import { FileWithPreview } from 'react-dropzone';

import { BannerConstants } from '../../typings/banners';
import { EditBannersState } from '../../typings/bannersEditState';
import { ValidationResultItem } from '../../typings/common';
import { BannerImageForEdit, BannerImageSize } from '../../typings/domain';
import { isImageHasSize } from '../ImageHelpers/ImageHelpers';

type ValidationRule = {
    code: string;
    isValid: (data: ValidationData) => boolean;
    getParams?: (
        constants: BannerConstants,
        options: ImageValidationOptions
    ) => Record<string, {}>;
};

type ImageValidationOptions = {
    path?: string;
};

type ValidationData = {
    image: FileWithPreview;
    state: EditBannersState;
    options: ImageValidationOptions;
};

// TODO DIRECT-102449
export const MAX_FILE_SIZE_UPLOAD = 122880;

export class ImagesAdValidator {
    static rules = {
        common: [
            {
                code: 'FILE_SIZE_LIMIT',
                isValid: function(data: ValidationData): boolean {
                    return data.image.size <= MAX_FILE_SIZE_UPLOAD;
                },
                getParams: function(
                    constants: BannerConstants
                ): Record<string, {}> {
                    return {
                        maxSize: MAX_FILE_SIZE_UPLOAD / 1024
                    };
                }
            },
            {
                code: 'DefectIds.INVALID_FORMAT',
                isValid: function(data: ValidationData): boolean {
                    return data.image.type.replace(/\/.*$/, '') === 'image';
                }
            }
        ]
    };

    // static mapTextToErrors(
    //     errors: ValidationRule[],
    //     path: string,
    //     banner: EditedBanner,
    //     constants: BannerConstants
    // ) {
    //     return errors.map((validationRule: ValidationRule) => {
    //         return {
    //             code: validationRule.code,
    //             text: imageUploadTextErrorMapper({
    //                 code: validationRule.code,
    //                 path: path,
    //                 params: validationRule.getParams
    //                     ? validationRule.getParams(constants)
    //                     : undefined
    //             })
    //         };
    //     });
    // }

    static checkSize(
        image: BannerImageForEdit,
        fixedSize?: BannerImageSize
    ): ValidationResultItem[] {
        if (fixedSize && !isImageHasSize(fixedSize, image)) {
            return [
                {
                    path: '',
                    code: fixedSize.isAdaptive
                        ? 'BannerDefectIds.Gen.IMAGE_SIZE_MODIFICATION_ADAPTIVE'
                        : 'BannerDefectIds.Gen.IMAGE_SIZE_MODIFICATION',
                    params: {
                        size: `${fixedSize.width}x${fixedSize.height}`
                    }
                }
            ];
        } else {
            return [];
        }
    }

    static validate(
        image: FileWithPreview,
        options: ImageValidationOptions,
        state: EditBannersState
    ): ValidationResultItem[] {
        let result: ValidationResultItem[] = [];
        const commonErrors = (ImagesAdValidator.rules.common || []).filter(
            (validationRule: ValidationRule) =>
                !validationRule.isValid({ image, state, options })
        );
        if (commonErrors.length) {
            result = commonErrors.map((validationRule: ValidationRule) => {
                return {
                    code: validationRule.code,
                    path: options.path || '',
                    params: validationRule.getParams
                        ? validationRule.getParams(state.constants, options)
                        : null
                };
            });
        }

        return result;
    }
}
